import React, { useContext, useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap' ;
import Backdrop  from '@material-ui/core/Backdrop'
import {makeStyles} from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import styles from './CreatePageTemplate.module.css'
import CollapsibleComponent from '../../../ReusableComponents/CollapseCard/CollapseCard';
import { sendRequestForPageTemplate } from '../../IFormDesignerLayout/RequestLogic';
import CustomizedAlert from '../../../ReusableComponents/Alert/CustomizedAlert';
// import AppViewer from '../../AppViewer/AppViewer';
import { CircularProgress } from '@material-ui/core';
import { AppContext } from '../../../Resources/CanvasContextFile';
import { useTranslation } from 'react-i18next';
import axios from '../../../axios';
import { useSelector } from "../../../Redux";
import SubformTemplate from './SubformTemplate'
import {test, createSmartFormState , recurseJson, sendRequestForControl, createUniqueId, addToAlreadyCreatedId, addIdsFromJsonToExistingIDs, addColumnObject, addRowObject, getFormId} from '../../IFormDesignerLayout/IFormDesignerLogic'
import  {ThemeJSON} from '../../IFormDesignerLayout/Theme/ThemeJSON';
import {downloadJson,sanitizeJson,sanitizeStringToJson,sanitizeStringToString} from '../../../Resources/globalFunctions';
import TestTemplate from "../../../Icons/testpic_template.png"
import { GetStateFromData } from '../../CustomHooks/CustomHooks';
import secureLocalStorage from "react-secure-storage";
import secureSessionStorage from '../../../utils/secureSessionStorage';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    // width: '1047px',
    // height: '394px',
    zIndex: 10000 ,
    color: '#fff',
  },
}));

export default function SelectTemplate(props) {
  const classes = useStyles();
  const AppContextVar = useContext(AppContext);
  var setFormState ;
  const { t } = useTranslation();
  if(AppContextVar!==undefined){
      setFormState = AppContextVar.setFormState;
  }
  const contexts = GetStateFromData();
  const { setSubForms, activeApplication, allSubForms,setFormState2,updateJson,formState2,imageBaseURL } = contexts.contexts;
  const { updatedComponentInFormState, removeAndUpdateComponentInFormState} =updateJson;
  const [open, setOpen] = React.useState(props.open);
  const [editingToolOption, setEditingToolOption] = React.useState('Resize Image');
  const [templateDetails, setTemplateDetails] = React.useState('');
  const [showLoader, setShowLoader] = React.useState(false);
  const [templateForm, setTemplateForm] = React.useState({ });
  const [templateType, setTemplateType] = React.useState('System defined');
  const [selectedTemplateOption, setSelectedTemplateOption] = React.useState();
  const [pageTemplates, setPageTemplates] = useState();
  const [subformTemplates, setSubformTemplates] = useState();
  const [imageFile, setImageFile] = useState();
  const [formBuffer, setFormBuffer] = useState();
  const [templateId, setTemplateId] = useState();
  const [select, setSelect] = useState(false);
  const [title, setTitle] = useState("");
  const [homePage, setHomePage] = useState("");
  const [dataObjectsContent, setDataObjectsContent] = useState({});
  const [newPageTemplate,setNewPageTemplate]=useState({});
  const [maskingData, setMaskingData] = useState(new Map());
  const [maskingKeys, setMaskingKeys] = useState([]);
  const [formBuillderMode,setFormBuillderMode]=useState("");
  const [newPage,setNewPage]=useState({
    processDefId:0,
    // formId:"",
    formName:`Page ${props.allPagesCount +1}`,
    formBuffer:JSON.stringify(props.defaultBuffer),
    isEncrypted:"N",
    lastModifiedOn:new Date(),
    deviceType:"A",
    formHeight:400,
    formWidth:400,
    existingFormId:"",
    formType:"P"
  });
  const translationStyles1=window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";   
  const launchpadKey=secureSessionStorage.getItem("Authorization") || JSON.parse(secureLocalStorage.getItem("launchpadKey"))?.token;
  var jwtToken = launchpadKey || undefined;   
  const [newSubForm, setNewSubForm] = useState({
    processDefId: 0,
    // fragmentId:"",
    fragmentName: "",
    //fragmentBuffer:"",
    fragmentBuffer: JSON.stringify(SubformTemplate),
    isEncrypted: "N",
    structureName: "",
    structureId: -1,
    lastModifiedOn: new Date(),
    deviceType: "A",
    formHeight: 400,
    formWidth: 400,
    projectId: "",
  });

  useEffect(()=>{
    let payload = { withCredentials: true };
    // http://localhost:8080/iforms/templates/Templatetype/{PAGE/FORM/TEMPLATE}
    if(props.componentFor==='page'){
      axios.get('/templates/Templatetype/PAGE',payload)
      .then((response)=>{  
        // console.log("pageTemp...",response)
        setPageTemplates(response.data)
      })
      .catch((err)=> console.log(err));
    } else if (props.componentFor === "subform") {
      axios
        .get("/templates/Templatetype/FORM", payload)
        .then((response) => {
          // console.log("pageTemp...",response)
          setSubformTemplates(response.data);
        })
        .catch((err) => console.log(err));
    }
  },[]);

  const templateOptions = {
    'Login Page' : [ {'label' : 'Image On Left' ,'src':require('../../../Icons/imageOnLeft.svg'), 'templateFormName' : 'LeftImageTemplateForm'},
                    {'label' : 'Image On Right' ,'src':require('../../../Icons/imageOnRight.svg'), 'templateFormName' : 'RightImageTemplateForm'},
                    {'label' : 'Without Image' ,'src':require('../../../Icons/withoutImage.svg'), 'templateFormName' : 'WithoutImageTemplateForm'},
                    {'label' : 'Background Image' ,'src':require('../../../Icons/BackgroundImage.svg'), 'templateFormName' : 'BackgroundImageTemplateForm'}],
    'Product Selection Page' : [ {'label' : 'Product Selection-Horizontal' ,'src':require('../../../Icons/imageOnLeft.svg')},
                    {'label' : 'Product Selection-Vertical' ,'src':require('../../../Icons/imageOnRight.svg')}],
    'Homepage' : ''
  }


  const pageTemplateOptions = {
    'Page Templates' : pageTemplates,
    'Subform Templates':subformTemplates,
  }
  var collapsibleItems = [];
  var collapsibleItems2 = [];


  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };
  const [isSelected,setIsSelected] = useState(false)
  function handleClickTemplate(prop) {
    setIsSelected(true)
    setShowLoader(true);
    setImageFile(prop.templateimage || TestTemplate);
    axios.get(`/templates/${prop.templateid}`,{withCredentials:true})
    .then(res=>{   
      setSelectedTemplateOption(res.data.templatename);
      setFormBuffer(res.data.templatebuffer);
      setTemplateId(prop.templateid)
      setSelect(true);
      setShowLoader(false);
    })
    .catch(()=>{
       console.log("ERROR ON getting template formjson", props.activeApplication.applicationId );
      setSelect(false);
    })  
  }
  
function setDefaultPageStyles(formData){
    var defaultPageStyle = new Object(ThemeJSON.page, {});
 //   console.log("defaultPageStyle::",defaultPageStyle);
    try{
        var styleKeys = Object.keys(formData.style);
        Object.keys(defaultPageStyle).forEach((key)=>{
            if(!styleKeys.includes(key)){ 
                formData.style[key] = defaultPageStyle[key];
            }
        })
    } catch(e){
         console.log(e);
    }
 }

 
 function callingDataObjects(){

    
    fetch(`${window.Configs.backEndUrl}/connection/`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
            "cabinetName": "bamdev5sp2",
            "userName": "dash",
            "authCode": "system123",
            "ip":window.Configs.bam_Ip,
            "port": window.Configs.bam_port,
          }),
        }).then(function(response) {
            return response.text();
          }).then(function(data) {

            // setSessionId(data);
            // setSessionIdConnection(data);  backEndUrl2
            
            // fetch(`${window.Configs.backEndUrl2}/mdm-rest/app/applogin`, {
             fetch("/mdm-rest/app/applogin", {
                method: "post",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
        
                    "locale": "en_US",
                    "user_index": "3",
                    "user_id": "badmin",
                    "session_id": data,
                    "cabinet_name": "bamdev5sp2",
                    "personal_name": "New User",
                    "family_name": "",
                    "client_gmt_offset": 0,
                    "batch_size": 10,
                    "server_gmt_offset": 330,
                    "theme_id": "0",
                    "eds": "N",
                    "udb_encrypt": "N"

                }),
              })
            })
            .then((result) => {
      
                 fetch("/mdm-rest/app/dataobjects",{  
                  method: "post",
                  headers: {
                    "Content-Type": "application/json",
                    "Authorization": jwtToken,
                  },
                  body: JSON.stringify({
                    
                    "parent_id":'29104', 
                    // "parent_id": `${props.appId}`, 
                    "type": "AP",
                    "sort_order": "A",
                    "order_by": "1",  
                    "records_to_fetch": "30", 
                    "mode": "tree"
                  
                  }),
        
                 }).then(function(response) {
                  return response.json();
                }).then(function(content) {
                    
                    //console.log("content.data content.data ", content.data_objects);

                    if(content.data.data_objects !== undefined)
                    {

                     var jsonDataSend={
                         data:content.data.data_objects
                     }   

                     var data=JSON.stringify(content.data.data_objects);


                    axios.post('/idesign/getDataObjectsforMapping',  {data},{withCredentials:true})     
                    .then((response) => {
                        // setDataObjectsState(response.data);
                        setDataObjectsContent(response.data);
                    }).catch(function (error) {
                        if (error.response) {
                        }
                        // alert(error);
                        console.log("error is", error)
                    });
                
                }
                })
                .catch((err)=>{
                   console.log("error is", err)
                 })

                 
              })

  }
  function fetchingMaskingForTextbox(){
    var remainingURL = "/idesign/fetchMaskingPattern";

    for (let [key, value] of maskingData) {
      var newPattern={};
      newPattern['Title']=key;
      newPattern['Value']=value;
    //   ControlsMap[fetchedProperty].children.push(newPattern);
        ///  ControlsMap["MaskingPattern"].children.push(newPattern);
    }

 //   console.log("controlsMapMasking " ,ControlsMap["MaskingPattern"]);

    axios.post(remainingURL, { withCredentials: true })
    .then((response) => {
    if (response && response.data && response.status === 200) {
         let maskingMap = new Map();
        for (const [key, value] of Object.entries(response.data)) {
            // maskingMap.set(key, value);
            maskingData.set(key, value);

            var newPattern={};
            newPattern['Title']=key;
            newPattern['Value']=value;
            maskingKeys.push(newPattern);

        }
       // setMaskingData(maskingMap);
    }
});

}

// console.log("formState - ",formState2)
  function handleTemplate(pageProperties){
    
    if(props.setAddNewPageLoader){
      props.setAddNewPageLoader(true);
    }
    
    pageProperties["selectedTemplateName"] = selectedTemplateOption
    let parsedJSON = JSON.parse(formBuffer)
    parsedJSON.style.selectedTemplateName = selectedTemplateOption
    setFormState2(parsedJSON);
    let form = JSON.parse(formBuffer)
    const repopulateJson = {
      formId: getFormId(),
      formJson: formBuffer
    };

    axios
      .post(
        "/idesign/populateFormStateFromJson",
        sanitizeJson(repopulateJson),
        { withCredentials: true }
      )
      .then((response) => {
        // console.log(response);
      })
      .catch((err) => console.log(err));
    props.setSelectedTemplateName(selectedTemplateOption)
  
    props.handleClose()
  }

  function createBlankPage() {
    if(props.setAddNewPageLoader){
      props.setAddNewPageLoader(true);
    }
    let newPageJson={...newPage,"existingFormId": props.activeApplication.applicationId};
    if(title){
      newPageJson={...newPageJson,"formName": title};
    }
    axios.post("/interfaces/",newPageJson,{withCredentials:true})
    .then(res=>{
        // console.log("NO ERROR ON adding new pages ");
        props.getAllPages();
        props.setAddNewPageLoader(false);
        window.activityStream("Username has created interface "+ res.data.formName,201,-1,props.activeApplication.applicationId,res.data.formId);
        props.setCurrentPage(res.data);
    })
    .catch(()=>{
         console.log("ERROR ON adding new pages ", props.activeApplication.applicationId );
        props.setAddNewPageLoader(false);
    })

    // handleClose();
    props.handleClose()
    
  }

  function getAllSubForms(){
    axios.get(`/widgets/${activeApplication.applicationId}`,{withCredentials:true})
    .then((res)=>{
        setSubForms([...(res.data)]);
    })
    .catch(()=>{
         console.log("ERROR ON LOADING PAGES OF APP ID ", activeApplication.applicationId );
    })
  }

  function addNewSubForm(){     
    const newSubFormJson={...newSubForm,"projectId": activeApplication.applicationId, fragmentName:title};
    axios.post("/widgets/",newSubFormJson,{withCredentials:true})
    .then(res=>{
        getAllSubForms();
    })
    .catch((err)=>{

      const errMessage = err.response.data.error;
            
      let errorMessage;
      if(errMessage === '502')
        errorMessage = "Widget_Name_Already_Exists";
      else if(errMessage === '501')
        errorMessage = "Widget_Name_Is_Empty";

      const alertData = {
          open: false,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentMsg: `${t(errorMessage)}`,
          autoHideDuration: 6000,
      };
      
      
        if(alertData.open === true) {
      return <CustomizedAlert alertData={alertData} />
      }
      // setSeverityMessage((prev)=> prev = `${t(errorMessage)}`);

      console.log("ERROR ON adding new pages ", activeApplication.applicationId );
    })
    props.handleClose();
  }
 

  function handlePageTitle(e){
    setTitle(e.target.value);
  }
  function handlePageCheckbox(e){
    setHomePage(e.target.checked);
  }
  useEffect(()=>{
    document.getElementById("backdropDiv")?.focus();
    
   },[])
  function handleEscapeKey(e){
    if(e.code === "Escape"){
      props.handleClose()
    } 
   }

  function handlePageTemplate(templateType, templateSubType, templateFormName){
    // setShowLoader(true);
    var jsonToSend = {'templateName' : templateFormName}; 
    sendRequestForPageTemplate(jsonToSend).then((response)=>{
        // console.log(response);
        if(response.status === 200){
          setTemplateForm(response.data);
          setSelectedTemplateOption(templateSubType);
          // setShowLoader(false);
        }
    })
    
  }
  function x(action,dir){   
    
  }
  if(templateOptions){
    Object.keys(templateOptions).forEach((key, index)=>{
      
      collapsibleItems.push(<CollapsibleComponent id={index+""} 
      heading={key} 
      body={createTemplateOption(key)}
      />);

    })
  }

  if(pageTemplateOptions){
    Object.keys(pageTemplateOptions).forEach((key, index)=>{
      if (props.componentFor === "subform" && key === "Subform Templates") {
        collapsibleItems2.push(
          <CollapsibleComponent
            id={index + ""}
            heading={key}
            body={createPageTemplateOption(key)}
          />
        );
      } else if (props.componentFor === "page" && key === "Page Templates") {
        collapsibleItems2.push(
          <CollapsibleComponent
            id={index + ""}
            heading={key}
            body={createPageTemplateOption(key)}
          />
        );
      }

    })
  }
  
function createTemplateOption(key) {
  switch(key){
    case 'Login Page' :  return(
            <div className={styles.templateOptionDiv}>
              {
              templateOptions[key].map((props)=>{
                return(
                  <Col className={styles.templateOptionParent} style={{ height: "auto"}}>
                    {/* <div className={styles.templateOption +' '+ selectedTemplateOption === props.label ? styles.selectedTemplateOption : null} 
                        onClick={()=> setSelectedTemplateOption(props.label)}> */}
                        <img src={(props.src).default} style={{width:'100%' , height: '100%'}} 
                        onClick={()=> handlePageTemplate(key,props.label,props.templateFormName)} alt='Select Template'/>
                    {/* </div> */}
                    <span style={{margin:'auto', textAlign:'center'}} 
                    className={selectedTemplateOption === props.label ? styles.definedText + ' ' + styles.selectedTemplateText : styles.definedText} 
                    onClick={()=> handlePageTemplate(key,props.label,props.templateFormName)}
                    title={props.label}
                    >
                        {t(props.label)}
                    </span>
                  </Col>
                )
              })}
            </div>
          )
    case 'Product Selection Page' :  return(
      <div className={styles.templateOptionDiv}>
        {
        templateOptions[key].map((props)=>{
          return(
            <Col className={styles.templateOptionParent} style={{ height: "auto"}}>
              {/* <div className={styles.templateOption +' '+ selectedTemplateOption === props.label ? styles.selectedTemplateOption : null} 
                  onClick={()=> setSelectedTemplateOption(props.label)}> */}
                  <img src={(props.src).default} style={{width:'100%' , height: '100%'}} 
                  onClick={()=> handlePageTemplate(key,props.templateFormName)} alt='Select Template Icon'/>
              {/* </div> */}
              <span style={{margin:'auto', textAlign:'center', marginBottom: "10px"}} 
              className={selectedTemplateOption === props.label ? styles.definedText + ' ' + styles.selectedTemplateText : styles.definedText} 
                  onClick={()=> handlePageTemplate(key,props.templateFormName)}
                  title={props.label}
                  >
                  {t(props.label)}
              </span>
            </Col>
          )
        })}
      </div>
    )
    case 'Home Page' : return null;
    default: return null;
  }
   
}


function createPageTemplateOption(key) {
  switch (key) {
    case "Page Templates":
      return (
        <>
          {/* <h1 style={{color:"#000"}}>hello</h1> */}
          {/* {console.log("pageTemp...", pageTemplateOptions)} */}
          <div className={styles.templateOptionDiv}>
            {pageTemplateOptions &&
              pageTemplateOptions[key] &&
              pageTemplateOptions[key].map((props) => {
                return (
                  <Col className={styles.templateOptionParent} style={{ height: "auto"}}>
                    <div
                      className={
                        selectedTemplateOption === props.templatename
                          ? styles.userDefinedTemplate +
                            " " +
                            styles.userDefinedSelectedTemplate
                          : styles.userDefinedTemplate
                      }
                    >
                      <div
                        style={{
                          background: `url(${props.templateimage || TestTemplate}) no-repeat`,
                          backgroundSize: "cover",
                          height: "88px",
                          width: "110px",
                        }}
                        onClick={() => handleClickTemplate(props)}
                      ></div>
                    </div>
                    {/* <div style={{background: `url(${props.templateimage}) no-repeat`, height: '114px', width: '92px'}} ></div> */}
                    {/* </div> */}
                    <span
                      style={{ margin: "auto", textAlign: "center" }}
                      className={
                        selectedTemplateOption === props.templatename
                          ? styles.definedText +
                            " " +
                            styles.selectedTemplateText
                          : styles.definedText
                      }
                      title={props.templatename}
                      // onClick={()=> handlePageTemplate(key,props.label,props.templateFormName)}
                    >
                      {props.templatename}
                    </span>
                  </Col>
                );
              })}
          </div>
        </>
      );
    case "Subform Templates":
      return (
        <>
          {/* <h1 style={{color:"#000"}}>hello</h1> */}
          {/* {console.log("pageTemp...", pageTemplateOptions)} */}
          <div className={styles.templateOptionDiv}>
            {pageTemplateOptions &&
              pageTemplateOptions[key] &&
              pageTemplateOptions[key].map((props) => {
                return (
                  <Col className={styles.templateOptionParent} style={{ height: "auto"}}>
                    <div
                      className={
                        selectedTemplateOption === props.templatename
                          ? styles.userDefinedTemplate +
                            " " +
                            styles.userDefinedSelectedTemplate
                          : styles.userDefinedTemplate
                      }
                    >
                      <div
                        style={{
                          background: `url(${props.templateimage || TestTemplate}) no-repeat`,
                          backgroundSize: "cover",
                          height: "88px",
                          width: "110px",
                        }}
                        onClick={() => handleClickTemplate(props)}
                      ></div>
                    </div>
                    {/* <div style={{background: `url(${props.templateimage}) no-repeat`, height: '114px', width: '92px'}} ></div> */}
                    {/* </div> */}
                    <span
                      style={{ margin: "auto", textAlign: "center" }}
                      className={
                        selectedTemplateOption === props.templatename
                          ? styles.definedText +
                            " " +
                            styles.selectedTemplateText
                          : styles.definedText
                      }
                      title={props.templatename}
                      // onClick={()=> handlePageTemplate(key,props.label,props.templateFormName)}
                    >
                      {props.templatename}
                    </span>
                  </Col>
                );
              })}
          </div>
        </>
      );
    default:
      return null;
  }
}

  return (
    <div>
      <Backdrop className={classes.backdrop} open={open} key={open}>
      <div tabIndex="0" onKeyDown={(e) => handleEscapeKey(e)} className={styles.backdropDiv} id="backdropDiv">
        <Row className={styles.backdropHeader}>
            {
              props.componentFor==='subform'?
              t('Create Subform')
              :
              props.isTemplate !== true ? t('Create Page') : t('Page Template')
            }
        </Row>
        <Row className={styles.backdropBody}>
          {props.isTemplate ? null : <Row className={styles.pageTitleRow}>
                <Col className={styles.pageTitleCol1} onClick={()=>setEditingToolOption('All')}>
                    <span className={styles.pageTitleText}>{t('Page Title')}</span>
                    <input aria-label={"Page Title"} type='text' className={styles.pageTitleInput} onChange={(e)=>handlePageTitle(e)}/>
                </Col>
                {
                  props.componentFor==='subform'?'':
                  <Col className={styles.pageTitleCol2} >
                      <input aria-label={"Set Home"} style={{height:"14px", width:"14px"}} type='checkbox' className={styles.pageTitleCheckbox}  onClick={(e)=>handlePageCheckbox(e)} />
                      <span className={styles.pageTitleText}>{t('Make this page as the Home Page of your Application')}</span>
                  </Col>
                }
            </Row>}
            
            
            <Row className={styles.backdropTemplateRow}>
                <Col className={styles.backdropLeftBody}>
                   <Col style={{ textAlign:"center" }} className={props.isTemplate ? styles.definingOptionColForTemplate :styles.definingOptionCol}>
                        <span style={{cursor:"pointer", height:"auto"}} className={templateType === 'System defined' ? styles.selectedDefinedText  + ' ' + styles.definedText : 
                        styles.definedText} onClick={()=>setTemplateType('System defined')}>
                          {t("System defined")}</span>
                        <span style={{cursor:"pointer", height:"auto"}} className={templateType === 'User defined' ? styles.selectedDefinedText  + ' ' + styles.definedText :
                         styles.definedText} onClick={()=>setTemplateType('User defined')}>
                          {t("User defined")}</span>
                    </Col>
                    <Col className={styles.templateOptionsTypeBody} style={{height:"370px",overflowY:"auto"}}>
                    {templateType === 'System defined' ? 
                      collapsibleItems.map((item)=>{
                        return item;
                      })
                    : templateType === 'User defined' ? 
                    collapsibleItems2.map((item)=>{
                      return item;
                    })
                    :
                    <></>
                    } 
                        {/* <CreatePageTemplate label={'Image On Left'} src={require("../../../Icons/imageOnLeft.svg")}/> */}
                    </Col>
                </Col>
                <Col className={styles.backdropRightBody}>
                  {props.isTemplate ? <Col className={styles.createBlankForTemplate}> </Col> :  <Col className={styles.createBlankCol} onClick={()=>setEditingToolOption('All')}>
                        {
                          props.componentFor==='subform'?
                          <Button disableFocusRipple
                          disableRipple
                          tabIndex={0}
                          className={`${title==="" ? styles.blankButtonDisabled :styles.blankButton} formBuilder-MuiButton-outlined`} disabled={title=="" ? true : false} onClick={()=>addNewSubForm()}> {t('Create From Blank')} </Button>
                          :
                          <Button disableFocusRipple
                          disableRipple
                          tabIndex={0}
                          className={`${title==="" ? styles.blankButtonDisabled :styles.blankButton} formBuilder-MuiButton-outlined`} disabled={title=="" ? true : false} onClick={()=>createBlankPage()}> {t('Create From Blank')} </Button>
                        }
                        
                    </Col>}
                   
                    <Col className={[styles.backdropRightTemplateBody, templateForm && Object.keys(templateForm).length ===0 ? 
                    styles.backdropRightTemplateLoadingBody : null].join(' ')} key= {selectedTemplateOption} >
                    {
                      <>
                      {
                       
                        /* <div 
                        style={{
                          // backgroundSize: "cover", 
                          backgroundImage: `url(${imageFile})`,
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "100% 100%", 
                          // background: `url(${imageFile}) cover`,
                          height: '369px', 
                          width: '654px'
                        }} 
                          ></div>  */
                          showLoader === true ? 
                          <CircularProgress />
                          :
                          imageFile && <img src={`${imageFile}`} style={{ height:"auto" , width :"100%", margin:"auto" }} alt='Img Icon' />

                        }
                      
                        </>
                    }
                    
                    </Col>
                </Col>
            </Row>
        </Row>
        <Row className={styles.backdropFooter} style={translationStyles1?{paddingLeft:"10px"}:null}>
            <Button disableFocusRipple
                          disableRipple
                          tabIndex={0} className={`${styles.cancelButton} formBuilder-MuiButton-outlined`}
                           onClick={()=>{props.handleClose()}}> {t('Cancel')} </Button>
            <Button  disableFocusRipple
                          disableRipple
                          tabIndex={0}
            className={`${isSelected === true ? styles.saveButton : title==="" ? styles.saveButtonDisabled : styles.saveButton} formBuilder-MuiButton-outlined`} onClick={()=>handleTemplate(props.pageProperties)} disabled={isSelected === true ? false : title ==="" ? true : false} > {t('Select')}</Button> 
            
        </Row>
      </div>
      </Backdrop>
    </div>
  );
}